import React, { useState, useEffect } from 'react'
import useStateRef from 'react-usestateref';
import { Pagination } from "@mui/material";
import { Row, Col, Table, Button, Form, Modal, Dropdown, } from "react-bootstrap";
import { Link, useNavigate } from 'react-router-dom';
import Card from "../../../../../components/Card";
import CustomToggle from "../../../../../components/dropdowns";

import config from "../../../../../config/config";
import apiPath from "../../../../../config/apipath";
import apiService from "../../../../../provider/apiService";
import "../../../../App.css";
import {useLocation } from 'react-router-dom';

const TableData = () => {
	
	const location = useLocation();
  
	useEffect(() => {

    if (location.state!=undefined || location.state!=null){

      setNewElg(location.state.NewElg);
      setEditElg(location.state.EditElg);
      setDeleteElg(location.state.DeleteElg);
      setViewElg(location.state.ViewElg);

      sessionStorage.setItem("PurchaseOnly_NewElg", NewElgRef.current);
      sessionStorage.setItem("PurchaseOnly_EditElg", EditElgRef.current);
      sessionStorage.setItem("PurchaseOnly_DeleteElg", DeleteElgRef.current);
      sessionStorage.setItem("PurchaseOnly_ViewElg", ViewElgRef.current);
}
    else
    {
      setNewElg(sessionStorage.getItem("PurchaseOnly_NewElg")==='true' ? true: false);
      setEditElg(sessionStorage.getItem("PurchaseOnly_EditElg")==='true' ? true: false);
      setDeleteElg(sessionStorage.getItem("PurchaseOnly_DeleteElg")==='true' ? true: false);
      setViewElg(sessionStorage.getItem("PurchaseOnly_ViewElg")==='true' ? true: false);
    }
    
    setpage(1);
    setuserId(0);
    setacmaster(0);
    Display();
  }, []);

const listPg = (event, value) => {
    setpage(value);
    setuserId(0);
    Display();
   
  };

  const navigate = useNavigate();
  const ActionAdd = () => {
	  sessionStorage.setItem("PurchaseOnly_Action", "Add");
	  sessionStorage.setItem("PurchaseOnly_EditId", "0");
    navigate('../dashboard/table/sales/purchaseonly/entry');
    //window.open('../salesbill/entry');
  };


  const ActionEdit = (editid) => {
	  
	sessionStorage.setItem("PurchaseOnly_Action", "Edit");
    sessionStorage.setItem("PurchaseOnly_EditId", editid);
    navigate('../dashboard/table/sales/purchaseonly/entry');
  };

const ActionDelete = (editid) => {
	  
	sessionStorage.setItem("PurchaseOnly_Action", "Delete");
    sessionStorage.setItem("PurchaseOnly_EditId", editid);
    navigate('../dashboard/table/sales/purchaseonly/entry');
  };

  const [show1, setShow1] = useState(false);
  const [sho, setSho] = useState(false);
  const [show, setShow] = useState(false);
  const [userId, setuserId, userIdRef] = useStateRef('0');
  const [nopage, setnopage, nopageRef] = useStateRef();
  const [page, setpage, pageRef] = useStateRef('1');
  const [acmaster, setacmaster, acmasterRef] = useStateRef('0');
  const [totalCount, settotalCount, totalCountRef] = useStateRef();
  const [currentpg, setcurrentpg, currentpgRef] = useStateRef();
  
  const [GridData, setGridData] = useState([]);
  const handleClose1 = () => setShow1(false);

  const [Search, setSearch, SearchRef] = useStateRef('');

  const [NewElg, setNewElg,NewElgRef] = useStateRef(false);
  const [EditElg, setEditElg,EditElgRef] = useStateRef(false);
  const [DeleteElg, setDeleteElg,DeleteElgRef] = useStateRef(false);
  const [ViewElg, setViewElg,ViewElgRef] = useStateRef(false);


  //const handleShow1 = () => setShow1(true);
  const handleShow1 = (data) => {
    setShow1(true);
    if (data == 'add') {
      setSho('Add New');
      setShow('Save');
    } else {
      setSho('Edit');
      setShow('Update');
    }
  }


async function Display() {
    try {
		
		
      let page_no = String(pageRef.current)
      let Rows_Page = String(config.pageCount)
      let user_id = String(userIdRef.current)
      let ac_master = String(acmasterRef.current)
    
      let postData = {
        PageNumber: page_no,
        RowspPage: Rows_Page,
        UserId: user_id,
        accountsmasterId: "0",
        eBranchCode: sessionStorage.getItem("BranchCode"),
        Search : SearchRef.current
      }

      let results = await apiService.postCall('purchaseonly/List', postData);
      if (results != "-1") {
        setGridData(results.data[0]);
        settotalCount(results.totalCount);
        setcurrentpg(postData.PageNumber);
      }

    } catch (error) {
      console.log(error);
    }
  }

   
  return (
    <>
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between">
              {/* <div className="header-title">
                <h4 className="card-title"></h4>
              </div> */}
              <div className="header-title">
                <h4 className="card-title">To Add, Modify Purchase Only Details.</h4>
              </div>
              <div>
                <div style={{ display: 'flex', marginLeft: '91px', alignItems: 'center' }}>
                  <div style={{ paddingRight: '10px' }}>
                    <Form.Control type="search" value={Search}  onChange={(e)=>{setSearch(e.target.value)}} className="form-control mr-sm-2" placeholder="Search" aria-label="Search" />
                  </div>
                  <div >
                    <Button className="text-center btn-primary btn-sm btn-icon mt-lg-0 mt-md-0 mt-3 " onClick={(e)=>{
                      setpage(1)
                      setcurrentpg(1)
                      Display()}}>
                      <i className="btn-inner">
                        <svg width="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="11.7669" cy="11.7666" r="8.98856" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></circle>
                          <path d="M18.0186 18.4851L21.5426 22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                        </svg>
                      </i>
                    </Button>
                  </div>
                </div>
              </div>
              <div className="col d-flex justify-content-end">
               {NewElg && <Button className="text-center btn-primary btn-icon mt-lg-0 mt-md-0 mt-3 " onClick={ActionAdd}>
                  <i className="btn-inner">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                    </svg>
                  </i>
                  <span>Add</span>
                </Button>}
              </div>
            </Card.Header>
            <Card.Body>
              <div className="table-responsive border-bottom my-3">
                <Table
                  responsive
                  striped
                  id="datatable"
                  className=""
                  data-toggle="data-table"
                >
                  <thead>
                    <tr>
                      <th></th>
                       <th>Bill No</th>
                       <th>Date</th>
                      <th>Amount Paid</th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {GridData.map((item) => (
                      <tr>
                        <td></td>
                        <td>{item.BillNo}</td>
                        <td>{item.BillDate}</td>
                        <td>{item.AmountPaid}</td>
                        {(EditElg || ViewElg) &&<td>
                          <Link className="btn btn-sm btn-icon text-primary flex-end" data-bs-toggle="tooltip" title="Edit" to="#" onClick={(e)=>ActionEdit(item.BillId)} >
                            <span className="btn-inner">
                              <svg width="18" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" >
                                <path d="M11.4925 2.78906H7.75349C4.67849 2.78906 2.75049 4.96606 2.75049 8.04806V16.3621C2.75049 19.4441 4.66949 21.6211 7.75349 21.6211H16.5775C19.6625 21.6211 21.5815 19.4441 21.5815 16.3621V12.3341" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                <path fillRule="evenodd" clipRule="evenodd" d="M8.82812 10.921L16.3011 3.44799C17.2321 2.51799 18.7411 2.51799 19.6721 3.44799L20.8891 4.66499C21.8201 5.59599 21.8201 7.10599 20.8891 8.03599L13.3801 15.545C12.9731 15.952 12.4211 16.181 11.8451 16.181H8.09912L8.19312 12.401C8.20712 11.845 8.43412 11.315 8.82812 10.921Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                <path d="M15.1655 4.60254L19.7315 9.16854" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                              </svg>
                            </span>
                          </Link>
                        </td>}
                        {DeleteElg && <td>
                          <Link className="btn btn-sm btn-icon text-danger" data-bs-toggle="tooltip" title="Delete" to="#" onClick={(e)=>ActionDelete(item.BillId)}>
                            <span className="btn-inner">
                              <svg width="18" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
                                <path d="M19.3248 9.46826C19.3248 9.46826 18.7818 16.2033 18.4668 19.0403C18.3168 20.3953 17.4798 21.1893 16.1088 21.2143C13.4998 21.2613 10.8878 21.2643 8.27979 21.2093C6.96079 21.1823 6.13779 20.3783 5.99079 19.0473C5.67379 16.1853 5.13379 9.46826 5.13379 9.46826" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                <path d="M20.708 6.23975H3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                <path d="M17.4406 6.23973C16.6556 6.23973 15.9796 5.68473 15.8256 4.91573L15.5826 3.69973C15.4326 3.13873 14.9246 2.75073 14.3456 2.75073H10.1126C9.53358 2.75073 9.02558 3.13873 8.87558 3.69973L8.63258 4.91573C8.47858 5.68473 7.80258 6.23973 7.01758 6.23973" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                              </svg>
                            </span>
                          </Link>

                        </td>}

                      </tr>
                    ))}
                  </tbody>

                </Table>
             
			 <div style={{ display: 'inline-flex', alignItems: 'center', padding: '3px 0 3px 0px', width: '100%', justifyContent: 'space-between' }}>

                  <div>
                    Showing {(currentpgRef.current - 1) * 10 + 1} to {currentpgRef.current * 10} of {totalCountRef.current} entries
                  </div>

                  <div>
                    <Pagination count={Math.ceil(totalCountRef.current / config.pageCount)} page={nopageRef.current} color="primary" onChange={listPg} />
                  </div>
                </div>
				
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default TableData;
